import { render, staticRenderFns } from "./twoDimension.vue?vue&type=template&id=473410a4&scoped=true"
import script from "./twoDimension.vue?vue&type=script&lang=js"
export * from "./twoDimension.vue?vue&type=script&lang=js"
import style0 from "./twoDimension.vue?vue&type=style&index=0&id=473410a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473410a4",
  null
  
)

export default component.exports